import { ReactElement } from 'react';

import { Inner, Wrapper } from './styles';
import { PresentationalToastProps } from './types';

export const PresentationalToastNotification = ({
	backgroundColor = 'toastBg',
	textColor = 'toastText',
	iconColor = 'toastIcon',
	leftEdgeColor = 'toastCardLeftEdgeColor',
	fromTop = false,
	children,
	isVisible,
	onPress,
	...props
}: PresentationalToastProps): ReactElement => {
	const asCard = props.asCard ?? false;
	return (
		<Wrapper
			$backgroundColor={backgroundColor}
			$textColor={textColor}
			$iconColor={iconColor}
			$asCard={asCard}
			$fromTop={fromTop}
			$leftEdgeColor={leftEdgeColor}
			$isVisible={isVisible}
			onPress={onPress}
		>
			<Inner>{children}</Inner>
		</Wrapper>
	);
};

export default PresentationalToastNotification;
